<template>
    <hts-drawer
        v-model="visible"
        color="main"
        :size="80"
        :title="$t('labels.billingAndCosting')"
        @close="close">
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <hts-finance-card
                title="Doanh thu"
                :amount="revenue"
                color="green" />
            <hts-finance-card
                title="Chi phí"
                :amount="cost"
                color="red" />
            <hts-finance-card
                title="Lợi nhuận"
                :amount="profit"
                :color="profit >= 0 ? 'blue' : 'orange'" />
        </div>

        <div>
            <payment-notes
                ref="paymentNotes"
                :trip="trip"
                :charge="charge"
                @refreshTableInvoice="refreshTableInvoice"
                @change="handleChange" />

            <!--
              <invoice
              ref="invoice"
              :trip="trip"
              @refreshTableDebit="refreshTableDebit" />
            -->
        </div>
    </hts-drawer>
</template>

<script setup lang="ts">
import PaymentNotes from './payment-note/list.vue'
const tripId = ref('')
const visible = ref(false)

const paymentNotes = ref()
const invoice = ref()
const trip = ref({} as { [key: string]: any })

const pricing = computed(() => {
  return trip.value?.pricing || {}
})
const revenue = computed(() => {
  return pricing.value?.revenue || 0
})
const cost = computed(() => {
  return pricing.value?.cost || 0
})
const profit = computed(() => {
  if (isNaN(revenue.value) || isNaN(cost.value)) {
    return 0
  }
  return revenue.value - cost.value
})
const charge = computed(() => {
  return trip.value?.charges?.[0] || { revenue: 0, cost: 0, profit: 0 }
})

const open = async (tripData: any) => {
  tripId.value = tripData._id
  await getData()
  visible.value = true
}

const getData = async () => {
  const api = $url.trip.trip.detail
  const data: any = await $api(api, { uriParams: { ID: tripId.value } })
  const resData: any = data.data.value

  if (resData?.success) {
    trip.value = resData.data
  }
}

const close = () => {
  visible.value = false
}

const refreshTableInvoice = () => {
  invoice.value && invoice.value.refreshTables()
}

const handleChange = () => {
  console.log('change')
  getData()
}

defineExpose({ open })
</script>
